import { paths, unauthenticatedFetch } from 'lib';
import useSWR from 'swr';

export const useHealthCheck = () => {
  return useSWR(paths.healthcheck(), unauthenticatedFetch, {
    refreshInterval: 10000,
  });
};
